module.exports = __webpack_public_path__ + "img/3.5b6963d3.jpg";